import { render, staticRenderFns } from "./CasesNew.vue?vue&type=template&id=5892850e&"
import script from "./CasesNew.vue?vue&type=script&lang=js&"
export * from "./CasesNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports